import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import { useTranslation } from "react-i18next";


function GroupContextMenu({
                              anchorEl,
                              open,
                              onClose,
                              onDeleteGroup,
                              onDissociateGroup,
                              groupId
                          }) {
    const { t } = useTranslation();

    return (
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            PaperProps={{ sx: { zIndex: 2000 } }}
        >
            <MenuItem
                onClick={() => {
                    onDeleteGroup(groupId);
                    onClose();
                }}
            >
                {t("delete_group")}
            </MenuItem>
            <MenuItem
                onClick={() => {
                    onDissociateGroup(groupId);
                    onClose();
                }}
            >
                {t("dissociate_group")}
            </MenuItem>
        </Menu>
    );
}

export default GroupContextMenu;
